export default "__VITE_ASSET__a$NHQjoD__"